import styled from 'styled-components'

export const StyledPreviousPrice = styled.p`
    color: #333;
    text-decoration: line-through;
`
